import React from 'react'

import { Row, Col, Divider, Form, Table } from '_zari/core'
import * as facturacionService from 'services/facturacion.service'

const ResumenVentas = ({ id, tipo, anio }) => {
  const [detallesData, setDetallesData] = React.useState({
    _id: '',
    _idCompania: '',
    condicionPago: '',
    _idDireccionSocio: '',
    _idPlantillaComentario: '',
    _idSede: '',
    _idSocio: '',
    anoMes: '',
    comentario: '',
    moneda: '',
    montoIcbper: null,
    montoIgvBaseImponible: null,
    montoIgvTotal: null,
    montoValorVentaTotal: null,
    numeroDocumento: null,
    serieDocumento: '',
    tipoDocumento: '',
    fechaEmision: '',
    fechaVencimiento: '',
    fileName: '',
    decimal: '',
    nombreTipoDocumento: '',
    nombreCondicionPago: '',
    compania: { _id: '', razonSocial: '', ruc: '', direccion: '' },
    sede: { _id: '', direccion: '' },
    totalEnLetras: '',
    socio: {
      _id: '',
      razonSocial: '',
      numeroDocumento: '',
      tipoDocumento: '',
      direcciones: [],
      nombreTipoDocumento: '',
      direccion: ''
    },
    detalles: [],
    qrBase64: '',
    logoBase64: '',
    plantillaPieDePagina: '',
    plantillaCabecera: '',
    textoPlantillaComentario: ''
  })

  React.useEffect(() => {
    facturacionService.verDetallesConsultaVentas(id, anio).then(({ data }) => {
      setDetallesData(data)
    })
  }, [id, anio])

  return (
    <>
      {tipo === 'portlet' && (
        <Row>
          <Col md={12}>
            <Divider title='DATOS DEL DOCUMENTO' noMargin />
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Tipo de Documento :' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.nombreTipoDocumento} noPadding />
                  </Col>
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Serie documento :' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.serieDocumento} noPadding />
                  </Col>
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='RUC :' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.compania.ruc} noPadding />
                  </Col>
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row className='mb-5'>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Número Documento :' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.numeroDocumento} noPadding />
                  </Col>
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Divider title='DATOS DE LA COMPAÑIA' noMargin />
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Razón Social :' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.compania.razonSocial} noPadding />
                  </Col>
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Dirección de la compañía:' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.compania.direccion} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row className='mb-5'>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Establecimiento del emisor :' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.sede.direccion} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Divider title='DATOS DE LA VENTA' noMargin />
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Condiciones de Pago: ' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.nombreCondicionPago} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Fecha Emisión :' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.fechaEmision} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Señor(es) :' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.socio.razonSocial} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text={detallesData.socio.nombreTipoDocumento} noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.socio.numeroDocumento} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Orden de Compra' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text='' noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Fecha Vencimiento' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text='' noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Vendedor' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text='' noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Moneda' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.moneda} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row className='mb-5'>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Direccion del Cliente' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.socio.direccion} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Divider title='DATOS DE LOS PRODUCTOS' noMargin />
            <Row className='mt-5 mb-5'>
              <Col className='text-center' md={12}>
                <Table
                  maxRowsShown={5}
                  filas={detallesData.detalles || []}
                  headRows={[
                    { label: 'Codigo' },
                    { label: 'Cantidad' },
                    { label: 'Unidad Medida' },
                    { label: 'Descripcion' },
                    { label: 'Precio' },
                    { label: 'Subtotal' },
                    { label: 'Dscto.' },
                    { label: 'Total' }
                  ]}
                  rowTemplate={(row, k) => (
                    <Table.Row key={k}>
                      <Table.Cell className='text-center'>{row.codigoProducto || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>{row.cantidad || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>{row.unidadMedida || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>{row.nombreProducto || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>
                        {parseFloat(row.montoValorVentaTotalConIgv) / parseFloat(row.cantidad) || '--'}
                      </Table.Cell>
                      <Table.Cell className='text-center'>{row.montoValorVentaTotalConIgv || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>{row.montoDescuentoTotalConIgv || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>{row.montoValorVentaTotalConIgv || '--'}</Table.Cell>
                    </Table.Row>
                  )}
                />
              </Col>
            </Row>
            <Row className='mb-5'>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Total Descuentos: ' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text='S/. 0' noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row className='mb-5'>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Op. Gravadas: ' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.montoIgvBaseImponible} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row className='mb-5'>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Op. Exoneradas: ' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text='S/. 0' noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row className='mb-5'>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='IGV: ' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.montoIgvTotal} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row className='mb-5'>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Icbper: ' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={detallesData.montoIcbper} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
            <Row className='mb-5'>
              <Col className='text-left' md={7}>
                <Form.Group>
                  <Form.Label text='Importe Total: ' noPadding md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.OnlyText text={`S/. ${detallesData.montoValorVentaTotal}`} noPadding />
                  </Col>
                  <Form.Label />
                </Form.Group>
              </Col>
              <Col className='text-left' md={5} />
            </Row>
          </Col>
        </Row>
      )}
      {tipo === 'modal' && (
        <Row>
          <Col md={12}>
            <Divider title='DATOS DEL DOCUMENTO' noMargin />
            <Row>
              <Col md={6}>
                <Row>
                  <Col className='text-sm-left' md={6}>
                    <Form.Group>
                      <Form.Label text='Tipo de Documento :' noPadding md={12} alignRightAt='sm' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text={detallesData.nombreTipoDocumento} noPadding />
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text='Serie documento :' noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text={detallesData.serieDocumento} noPadding />
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text='RUC :' noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text={detallesData.compania.ruc} noPadding />
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text='Número Documento :' noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text={detallesData.tipoDocumento} noPadding />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Divider title='DATOS DE LA VENTA' noMargin />
            <Row>
              <Col md={6}>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text='Condiciones de Pago: ' noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text={detallesData.nombreCondicionPago} noPadding />
                  </Col>
                </Row>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text='Fecha Emisión :' noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text={detallesData.fechaEmision} noPadding />
                  </Col>
                </Row>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text='Señor(es) :' noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text={detallesData.socio.razonSocial} noPadding />
                  </Col>
                </Row>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text={detallesData.socio.nombreTipoDocumento} noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text={detallesData.socio.numeroDocumento} noPadding />
                  </Col>
                </Row>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text='Direccion del Cliente' noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text={detallesData.socio.direccion} noPadding />
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text='Orden de Compra' noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text='' noPadding />
                  </Col>
                </Row>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text='Fecha Vencimiento' noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text='' noPadding />
                  </Col>
                </Row>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text='Vendedor' noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text='' noPadding />
                  </Col>
                </Row>
                <Row>
                  <Col className='text-left' md={6}>
                    <Form.Group>
                      <Form.Label text='Moneda' noPadding md={12} alignRightAt='md' />
                    </Form.Group>
                  </Col>
                  <Col className='text-left' md={6}>
                    <Form.OnlyText text={detallesData.moneda} noPadding />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Divider title='COMENTARIO' noMargin />
            <Row>
              <Col className='text-left' md={12}>
                <Form.Group>
                  <Form.Label text={detallesData.comentario} noPadding md={12} />
                </Form.Group>
              </Col>
            </Row>
            <Divider title='DATOS DE LOS PRODUCTOS' noMargin />
            <Row className='mb-5'>
              <Col className='text-center' md={12}>
                <Table
                  maxRowsShown={5}
                  filas={detallesData.detalles || []}
                  headRows={[
                    { label: 'Codigo' },
                    { label: 'Cantidad' },
                    { label: 'Unidad Medida' },
                    { label: 'Descripcion' },
                    { label: 'Precio' },
                    { label: 'Subtotal' },
                    { label: 'Dscto.' },
                    { label: 'Total' }
                  ]}
                  rowTemplate={(row, k) => (
                    <Table.Row key={k}>
                      <Table.Cell className='text-center'>{row.codigoProducto || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>{row.cantidad || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>{row.unidadMedida || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>{row.nombreProducto || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>
                        {parseFloat(row.montoValorVentaTotalConIgv) / parseFloat(row.cantidad) || '--'}
                      </Table.Cell>
                      <Table.Cell className='text-center'>{row.montoValorVentaTotalConIgv || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>{row.montoDescuentoTotalConIgv || '--'}</Table.Cell>
                      <Table.Cell className='text-center'>{row.montoValorVentaTotalConIgv || '--'}</Table.Cell>
                    </Table.Row>
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col className='text-left' md={6}>
                <Form.Group>
                  <Form.Label text='Total Descuentos: ' noPadding md={12} alignRightAt='md' />
                </Form.Group>
              </Col>
              <Col className='text-left' md={6}>
                <Form.OnlyText text='S/. 0' noPadding />
              </Col>
            </Row>
            <Row>
              <Col className='text-left' md={6}>
                <Form.Group>
                  <Form.Label text='Op. Gravadas: ' noPadding md={12} alignRightAt='md' />
                </Form.Group>
              </Col>
              <Col className='text-left' md={6}>
                <Form.OnlyText text={detallesData.montoIgvBaseImponible} noPadding />
              </Col>
            </Row>
            <Row>
              <Col className='text-left' md={6}>
                <Form.Group>
                  <Form.Label text='Op. Exoneradas: ' noPadding md={12} alignRightAt='md' />
                </Form.Group>
              </Col>
              <Col className='text-left' md={6}>
                <Form.OnlyText text='S/. 0' noPadding />
              </Col>
            </Row>
            <Row>
              <Col className='text-left' md={6}>
                <Form.Group>
                  <Form.Label text='IGV: ' noPadding md={12} alignRightAt='md' />
                </Form.Group>
              </Col>
              <Col className='text-left' md={6}>
                <Form.OnlyText text={detallesData.montoIgvTotal} noPadding />
              </Col>
            </Row>
            <Row>
              <Col className='text-left' md={6}>
                <Form.Group>
                  <Form.Label text='Icbper: ' noPadding md={12} alignRightAt='md' />
                </Form.Group>
              </Col>
              <Col className='text-left' md={6}>
                <Form.OnlyText text={detallesData.montoIcbper} noPadding />
              </Col>
            </Row>
            <Row>
              <Col className='text-left' md={6}>
                <Form.Group>
                  <Form.Label text='Importe Total: ' noPadding md={12} alignRightAt='md' />
                </Form.Group>
              </Col>
              <Col className='text-left' md={6}>
                <Form.OnlyText text={`S/. ${detallesData.montoValorVentaTotal}`} noPadding />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  )
}

export default React.memo(ResumenVentas)
